import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="bg-slate-900 text-white py-16" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <h3 className="text-2xl mb-4" style={{ fontFamily: '"DM Serif Display", serif' }}>
              HandyVerse
            </h3>
            <p className="text-slate-400 text-sm leading-relaxed">
              {t('footerDesc')}
            </p>
            <div className="mt-4 flex items-center gap-2 text-sm text-slate-400">
              <span>📍</span>
              <span>Gatineau, Outaouais, Québec, Canada</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-300">
              {t('services')}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/categories" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('categories')}
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('findPro')}
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('createProProfile')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-300">
              {t('popularCategories')}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/search?category=batiment" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('construction')}
                </Link>
              </li>
              <li>
                <Link to="/search?category=reparation" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('repair')}
                </Link>
              </li>
              <li>
                <Link to="/search?category=services" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('servicesCategory')}
                </Link>
              </li>
              <li>
                <Link to="/search?category=nature" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('nature')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Region */}
          <div>
            <h4 className="font-semibold mb-4 text-sm uppercase tracking-wider text-slate-300">
              {t('region')}
            </h4>
            <ul className="space-y-3 text-slate-400 text-sm">
              <li>{t('gatineau')}</li>
              <li>{t('outaouais')}</li>
              <li>{t('quebec')}, {t('canada')}</li>
              <li className="pt-2">
                <a href="mailto:contact@handyverse.ca" className="hover:text-white transition-colors">
                  contact@handyverse.ca
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © 2024 HandyVerse. Tous droits réservés / All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="#" className="text-slate-500 hover:text-white transition-colors text-sm">
              Mentions légales
            </Link>
            <Link to="#" className="text-slate-500 hover:text-white transition-colors text-sm">
              CGU
            </Link>
            <Link to="#" className="text-slate-500 hover:text-white transition-colors text-sm">
              Confidentialité
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
